module.exports = __webpack_public_path__ + "static/img/13.120759c6.png";